<template>
<div class="body">
  <div class="title">
    账号管理
    <!-- 面包屑导航区域 -->
    <div class="fansk">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/shouye' }"><span class="dsadf">
            首页
          </span></el-breadcrumb-item>
        <el-breadcrumb-item>系统设置</el-breadcrumb-item>
        <el-breadcrumb-item>账号管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
  </div>
  <div class="btnsearch">
    <div class="left">
      <el-button type="primary" icon="el-icon-plus" size="medium" @click="routeAdd">添加账号</el-button>
    </div>
    <div class="center"></div>
    <div class="right">
      <el-form :inline="true">
        <el-form-item >
          <el-select  placeholder="跳转类型" v-model="query.types" @change="Discountsearch"  style="min-width: 168px;width: 168px" clearable>
            <el-option  name="selected" :value="0" label="全部 "></el-option>
            <el-option  name="selected" :value="1" label="普通管理员 "></el-option>
            <el-option  name="selected" :value="2" label="超级管理员 "></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select  placeholder="启用状态" v-model="query.is_status" @change="Discountsearch"  style="min-width: 168px;width: 168px" clearable>
            <el-option  name="selected" :value="0" label="全部 "></el-option>
            <el-option  name="selected" :value="1" label="禁用 "></el-option>
            <el-option  name="selected" :value="2" label="启用 "></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            placeholder="排序/跳转链接/链接说明 " v-model="query.keyword"  @change="Discountsearch" style="min-width: 168px;width: 336px;">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </el-form-item>
      </el-form>
    </div>
  </div>
  <vxe-table
    :data="queryForm"
    border
    stripe
    resizable
    highlight-cell
    highlight-hover-row
    max-height="750"
    class="mytable-scrollbar"
    show-overflow
    keep-source
    align="center"
    highlight-current-column="true"
  >
    <vxe-table-column field="realname" title="用户名" min-width="100">
    </vxe-table-column>
    <vxe-table-column field="content" title="头像" min-width="170">
      <template slot-scope="scope">
        <img :src="scope.row.userface" alt="" class="imgs">
      </template>
    </vxe-table-column>
    <vxe-table-column field="mobile" title="手机号" min-width="100">
    </vxe-table-column>
    <vxe-table-column  title="权限" min-width="130">
      <template slot-scope="scope">
        <el-tag type="success" v-if="scope.row.admin_types === 0">普通管理员</el-tag>
        <el-tag   type="warning" v-else-if="scope.row.admin_types === 1">超级管理员</el-tag>
      </template>
    </vxe-table-column>
    <vxe-table-column field="url" title="账号状态" min-width="100">
      <template  slot-scope="scope">
        <el-switch
          @change="sexChangeListOption(scope.row)"
          v-model="scope.row.zhuangtai"
          active-color="#13ce66"
          inactive-color="#ff4949">
        </el-switch>
        <span :style="{'color': (scope.row.is_status === 0 ? '#F7D05C':'#17ab3f')}">
            {{scope.row.is_status===1 ?'启用':'禁用'}}
          </span>
      </template>
    </vxe-table-column>
    <vxe-table-column field="create_time" title="添加时间" min-width="100">
    </vxe-table-column>
    <vxe-table-column title="操作" min-width="200">
      <template slot-scope="scope">
        <!-- 修改按钮 -->
        <button  @click="PushEdits(scope.row)" icon="el-icon-edit" class="bianji">编辑</button>
        <!--      删除     -->
        <button  @click="PushDelete(scope.row)" icon="el-icon-delete" class="shanchu">删除账号</button>
      </template>
    </vxe-table-column>
  </vxe-table>
  <div v-if="pageshow">
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="cur_page"
      :page-sizes="[10]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>
  <vxe-modal width="336" ref="shifoushangjia" height="182" size="small" :show-footer="false" :showHeader="false" :show-close="true">
    <div class="popchuangkou">
      <img src="../../assets/img/closeaaaa.png" alt="" class="dsff" @click="plClose">
      <div class="titledd">
        是否确认{{itemcc.is_status===1?'禁用':'开启'}}该账号?
      </div>
      <div class="bobox">
        <button class="queren" @click="plqueren">
          确认
        </button>
        <button class="quxiao"  @click="plClose">
          取消
        </button>
      </div>
    </div>
  </vxe-modal>
</div>
</template>

<script>
import { adminuserDel, adminuserList, adminuserSetstatusval } from '@/api/zhanghaoguanli'
import { cardlist } from '@/api/tongxunlu'

export default {
  name: 'zhanghaoguanli',
  data () {
    return {
      cur_page: 1,
      pageshow: true,
      query: {
        token: sessionStorage.getItem('token'),
        types: 0,
        is_status: 0,
        keyword: '',
        page: 1,
        pagesize: 10
      },
      total: null,
      queryForm: [],
      itemcc: {}
    }
  },
  created () {
    this.list()
  },
  methods: {
    PushEdits (row) {
      this.$store.commit('setquanxianID', row.id)
      this.$router.push('/bianjiwodezhanghao')
    },
    Discountsearch () {
      this.cur_page = 1
      this.list()
      this.pageshow = false// 让分页隐藏
      this.$nextTick(() => { // 重新渲染分页
        this.pageshow = true
      })
    },
    PushDelete (row) {
      this.$confirm("确认删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          const obj = {
            token: sessionStorage.getItem('token'),
            user_id: row.id
          }
          adminuserDel(obj).then(({ data: res }) => {
            console.log('res', res)
            if (res.result === -1) {
              this.$message({
                message: res.msg,
                type: 'error',
                duration: '2000'
              })
              setTimeout(() => {
                window.sessionStorage.clear()
                this.$router.push('/login')
              }, 1000)
            }
            if (res.result === 0) {
              this.$message({
                message: res.msg,
                type: 'error',
                duration: '2000'
              })
              return false
            }
            if (res.result === 1) {
              this.$message({
                message: res.msg,
                type: 'success',
                duration: '2000'
              })
              this.list()
            }
          })
        })
        .catch(() => {});
    },
    plqueren () {
      if (this.itemcc.is_status === 1) {
        this.itemcc.is_status = 0
      } else {
        this.itemcc.is_status = 1
      }
      const obj = {
        token: sessionStorage.getItem('token'),
        user_id: this.itemcc.id,
        is_status: this.itemcc.is_status
      }
      adminuserSetstatusval(obj).then(({ data: res }) => {
        console.log('res', res)
        if (res.result === -1) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: '2000'
          })
          setTimeout(() => {
            window.sessionStorage.clear()
            this.$router.push('/login')
          }, 1000)
        }
        if (res.result === 0) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: '2000'
          })
          return false
        }
        if (res.result === 1) {
          this.$message({
            message: res.msg,
            type: 'success',
            duration: '2000'
          })
          this.$refs.shifoushangjia.close()
          this.list()
        }
      })
    },
    handleSizeChange (val) {
      this.query.pagesize = val
      this.handleCurrentChange(this.query.page)
    },
    handleCurrentChange (val) {
      this.query.page = val
      cardlist(this.query).then(({ data: res }) => {
        console.log('res', res)
        this.queryForm = res.list
        this.total = res.total
      })
    },
    plClose () {
      this.$refs.shifoushangjia.close()
      this.list()
    },
    sexChangeListOption (item) {
      console.log('row', item)
      this.itemcc = item
      this.$refs.shifoushangjia.open()
    },

    list () {
      adminuserList(this.query).then(({ data: res }) => {
        console.log('res', res)
        this.queryForm = res.list
        this.total = res.total
        this.queryForm.forEach(i => {
          if (i.is_status === 1) {
            i.zhuangtai = true
          } else if (i.is_status === 0) {
            i.zhuangtai = false
          }
        })
      })
    },
    routeAdd () {
      this.$router.push('/tianjiazhanghao')
    }
  }
}
</script>

<style scoped lang="less">
.popchuangkou{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  .mbP{
    margin-bottom: 24px;
  }
  .dsff{
    position: absolute;
    right: 0;
    top: 0;
    width: 20px;
    height: 20px;
  }
  .titledd{
    margin-top: 22px;
    font-size: 18px;
    font-family: PingFang SC, PingFang SC-Bold;
    font-weight: 500;
    text-align: left;
    color: #2e2e2e;
  }
  .einput{
    width: 253px;
    height: 44px;
    opacity: 1;
    background: #fbfbfb;
    border-radius: 5px;
  }
  .bobox{
    margin-top: 43px;
    display:flex;
    flex-direction: row;
    align-items: center;
  }
  .queren{
    width: 95px;
    height: 36px;
    opacity: 1;
    background: linear-gradient(135deg,#3d9aff, #3380f2);
    border-radius: 2px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: left;
    color: #ffffff;
    letter-spacing: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    margin-right: 12px;
  }
  .quxiao{
    width: 95px;
    height: 36px;
    opacity: 1;
    background: rgba(61,154,255,0.10);
    border-radius: 2px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: left;
    color: #3d9aff;
    letter-spacing: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
  }
}
.imgs{
  width: 100px;
  height: 100px;
}
.bianji{
  width: 78px;
  height: 37px;
  opacity: 1;
  border: 1px solid rgba(61,154,255,0.50);
  border-radius: 2px;
  font-size: 12px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #3d9aff;
  letter-spacing: 0px;
  background: white;
  margin-right: 10px;
}
.shanchu{
  width: 78px;
  height: 37px;
  opacity: 1;
  border: 1px solid rgba(61,154,255,0.50);
  border-radius: 2px;
  font-size: 12px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #e54848;
  letter-spacing: 0px;
  background: white;
}
.body {
  display: flex;
  flex-direction: column;

.title {
  opacity: 1;
  font-size: 30px;
  font-family: PingFang SC, PingFang SC-Heavy;
  font-weight: 800;
  text-align: left;
  color: #2e2e2e;
  letter-spacing: 0px;
  margin-bottom: 35px;
  display: flex;
  flex-direction: row;
  align-items: center;

.fansk {
  margin-top: 30px;
  margin-left: 32px;
}

.dsadf {
  color: #3D9AFF;
}
}
.btnsearch{
  display:flex;
  flex-direction: row;
  align-items: center;
.left{
  margin-right: 150px;
.btn{
  width: 124px;
  height: 43px;
  opacity: 1;
  background: linear-gradient(135deg,#1bb745, #17ab3f);
  border-radius: 5px;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  letter-spacing: 0px;
  border: none;
}
}
  .center{
    flex: 1;
  }
.right{
  margin-top: 27px;
}
}
}
</style>
